export const hotelRoomBlocksPageData = {
  seo: {
    title: 'Hotel Room Blocks reserve with no financial commitment | Joy',
    content: `Hotel Room Blocks with Joy
    Our hotel concierge team is here to help. From curating accommodations to fit every need, to securing hotel room blocks, all without requiring your credit card as a security deposit for your guests.`,
  },
  heroSection: {
    title: 'Introducing Hotel<br />Room Blocks with Joy.',
    bullet1: 'Exclusive hotel room block room rates up to 30% off.',
    bullet2: 'Reserve blocks with no financial commitment.',
    bullet3: 'Personal travel concierge for you and your guests.',
    bullet4: '* Currently only available to residents of the United States.',
    buttonStarted: 'Get Started',
  },
  personalTravelConciergeSection: {
    title: 'Personal Travel Concierge',
    subtitle: 'We do the work, you do the fun.',
    description:
      'Ensuring your guests have a comfortable and convenient place to stay is just one of the countless details of wedding planning. Our concierge team is here to help, from curating accommodations to fit every need, to securing hotel room blocks and helping guests book.',
    buttonStarted: 'Get Started',
    images: [
      {
        title: 'Conrad, New York',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
      {
        title: 'Hotel Adagio',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing1.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
      {
        title: 'Courtyard San Francisco',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing2.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
      {
        title: 'San Francisco Proper',
        image: {
          url: 'hotel-room-blocks/PersonalTravelConcierge/Listing3.png',
        },
        sm: {
          width: 360,
          height: 270,
        },
        belowSm: {
          width: 360,
          height: 270,
        },
      },
    ],
  },
  riskFreeReservationsSection: {
    eyebrow: 'Risk-Free Reservations',
    title: 'Millions of rooms.<br />Zero money down.',
    body: `You’re already spending enough money on the fun. That’s why we let you reserve a block of rooms, no credit card required. In addition to getting you the cheapest rates, we’ll take on the risk—that means no cancelation fees if your hotel room blocks aren't fully booked.`,
    buttonStarted: 'Get Started',
    slide: {
      bgColor: '#E0F9FF',
      bgImage: 'hotel-room-blocks/RiskFreeReservation/Desktop-Risk-free.png',
      bgImageMobile: 'hotel-room-blocks/RiskFreeReservation/Mobile-Risk-free.png',
      eyebrowColor: 'humanaDark4',
      titleColor: 'neutra6',
      bodyColor: 'neutra6',
    },
  },
  exclusiveGroupRatesSection: {
    eyebrow: 'Exclusive Group Rates',
    title: 'Up to 30% off is always something to party about.',
    description: `No matter how small or large your party is, we’ll find the best guest rooms and group rates with your favorite hotels and resorts, whether you’re right in your back yard or planning a destination wedding.`,
    buttonStarted: 'Get Started',
  },
  premiumPerksUpgradesSection: {
    eyebrow: 'Premium Perks & Upgrades',
    title: 'Elevate your stay, right this way.',
    description: `From bridal suite upgrades and complementary spa experiences to special in-room amenities for your wedding guests, our team will open doors and do our best to get you the best.`,
    buttonStarted: 'Get Started',
  },
  expertRecommendationsSection: {
    eyeBrow: 'Expert Recommendations',
    title: 'Hotel blocks curated just for you.',
    content:
      'Tell us your every need, and we’ll present the perfect set of options across multiple price points. Whether you’re looking for something near the wedding venue or far out digs, our experts will help you select and block out the best options for your guests. Your guests book what they need, you enjoy no obligations.',
    buttonStarted: 'Get Started',
    recommendationBestPrice: 'Best Price',
    recommendationNearVenue: 'Near Venue',
    recommendationBestPerks: 'Best Perks',
    recommendationThingsToDo: 'Things To Do',
  },
  streamlinedCommunicationSection: {
    eyeBrow: 'Streamline Communication',
    title: 'The Personal Travel Concierge for your guests.',
    content:
      'Before check-in or after the after party, we provide you with a dedicated concierge team member— a central point of contact for your guests—who can help them navigate their options, book rooms, and answer any and all questions leading up to your event.',
    buttonStarted: 'Get Started',
    bgImage: 'hotel-room-blocks/StreamlinedCommunication/Streamlined-Communication.png',
  },
  weddingWebsiteSection: {
    eyeBrow: 'Wedding Website',
    title: 'Share it with Joy.',
    content:
      'With Joy, you get a beautiful event website to share all the details of your event. Easily share your room blocks on your Joy website or send a direct link and let guests browse and reserve their hotel rooms from right on your website.',
    buttonCreateYourWebsite: 'Create Your Website',
    buttonLearnMore: 'Learn More',
    featuresData: [
      {
        image: 'honeymoon-fund/icon-website-v2.svg',
        title: 'Free Wedding</br>Websites',
      },
      {
        image: 'honeymoon-fund/icon-cards-v2.svg',
        title: 'Save the Dates, Invites & Matching Prints',
      },
      {
        image: 'honeymoon-fund/icon-wand-v2.svg',
        title: 'Powerful</br>Planning Tools',
      },
      {
        image: 'honeymoon-fund/icon-support-v2.svg',
        title: 'Personal</br>Customer Support',
      },
    ],
  },
} as const;
